import type { IconSvgObject } from './types';

const FirewallIcon: IconSvgObject = [
  ["path", { d: "M20 14H4C2.89543 14 2 14.8954 2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20L22 16C22 14.8954 21.1046 14 20 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 18H22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 18L12 14M7 22V18M17 22L17 18", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M19 11C19 10 17.9809 8.63931 16.499 7.6C12.5064 4.8 12.0628 2 12.0628 2C12.0628 2 7.94433 5.6 10.2883 10C8.15899 10.32 7.16797 8 6.93863 6.8C5.95522 8.08998 4.96435 9 5.00093 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default FirewallIcon;
